import { useContext, useEffect } from "react"
import { MODES } from "../components/atoms/select/CustomerOrFundSelect"
import { PositionsContext } from "../context/PositionsContext"
import { PositionsService } from "../service/PositionsService"
import { ASSET_POSITIONS_COLUMNS, getWidth } from "../utils/reportsConfig"
import { downloadExcelFile } from "../utils/utils"
import { useSupabase } from "./context/useSupabase"

export const usePositions = () => {
  const {
    isExplodedView,
    setIsLoading,
    referenceDate,
    setReferenceDate,
    customerOrFund,
    setCustomerOrFund,
    isStructuresView,
    setPositions,
    setGraph,
    setCustomersOrFunds,
    datesAvailable,
    setDatesAvailable,
    hideEmptyClasses,
    mode,
    locale,
    visualizationType,
    assetName,
    reload,
    setIsToExpandAll,
  } = useContext(PositionsContext)
  const supabase = useSupabase()

  const service = PositionsService({
    supabase,
    customerOrFund,
    isExplodedView,
    isStructuresView,
    locale,
    referenceDate,
    hideEmptyClasses,
    visualizationType,
    mode,
    assetName,
  })

  const fetchAvailableDates = async () => {
    if (!datesAvailable || !datesAvailable.length) setDatesAvailable(await service.getDatesAvailable())
    if (!referenceDate) setReferenceDate(datesAvailable[0])
  }

  const fetchPositions = async () => {
    if (!referenceDate) return

    const { customersOrFunds, positions, graph } = isStructuresView ? await service.getPositionsByStructures() : await service.getPositions()

    setCustomersOrFunds(customersOrFunds)
    setPositions(positions)
    setGraph(graph)
    setIsToExpandAll(false)
    setIsLoading(false)
  }

  const handleExport = async () => {
    const data = await service.handleExportExcel()
    const columnsAvailable = Array.from(new Set(data.map((item) => Object.keys(item)).flat()))
    const columns = columnsAvailable.map((column) => ({ name: column, width: getWidth(ASSET_POSITIONS_COLUMNS, column) }))

    let filename = "POSICAO_DE_ATIVOS_"

    if (customerOrFund && mode === MODES.CUSTOMER) filename += `${data[0].Cliente.replaceAll(" ", "_")}_`
    else if (customerOrFund && mode === MODES.FUND) filename += `${data[0].Fundo.replaceAll(" ", "_")}_`
    else if (!customerOrFund && mode === MODES.CUSTOMER) filename += "CLIENTES_"
    else if (!customerOrFund && mode === MODES.FUND) filename += "FUNDOS_"

    filename += `${data[0].Data}.xlsx`

    downloadExcelFile(data, "Posição de Ativos", columns, filename)
  }

  useEffect(() => {
    setIsLoading(true)
    fetchAvailableDates()
    fetchPositions()
  }, [customerOrFund, isExplodedView, locale, referenceDate, hideEmptyClasses, visualizationType, mode, assetName, reload, isStructuresView])

  useEffect(() => {
    setCustomerOrFund(null)
  }, [mode])

  return { handleExport }
}
